export default [
    {
        key: 'generate',
        component: () => import('@/views/generate')
    },
    {
        key: 'hello',
        component: () => import('@/views/hello')
    },
    {
        key: 'profile',
        component: () => import('@/views/profile')
    },
    {
        key: 'respondent-questions',
        component: () => import('@/views/testing/respondent'),
        options: {
            stage: 1
        }
    },
    {
        key: 'literacy',
        components: {
            default: () => import('@/views/testing/literacy-numeracy'),
            aside: () => import('@/views/testing/literacy-numeracy/aside'),
        },
        options: {
            asideWidth: 480,
            stage: 2
        }
    },
    {
        key: 'numeracy',
        components: {
            default: () => import('@/views/testing/literacy-numeracy'),
            aside: () => import('@/views/testing/literacy-numeracy/aside'),
        },
        options: {
            asideWidth: 480,
            stage: 3
        }
    },
    {
        key: 'problem-solving',
        components: {
            default: () => import('@/views/testing/problem-solving'),
            aside: () => import('@/views/testing/problem-solving/aside'),
        },
        options: {
            asideWidth: 350
        }
    },
    {
        key: 'big5',
        component: () => import('@/views/testing/big5'),
        options: {
            stage: 4
        }
    },
    {
        key: 'results',
        component: () => import('@/views/results')
    }
]
